// This file serves as a central hub for re-exporting pre-typed Redux hooks.
import type { LlinkidDispatch } from '@store/index';
import type { RootState } from '@store/storeSetup';
import { useDispatch, useSelector } from 'react-redux';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch.withTypes<LlinkidDispatch>();
export const useTypedSelector = useSelector.withTypes<RootState>();
